import { CircleAlert } from "lucide-react";
import { createIcon } from "@/components/icons/create-icon";

export const AlertCircleIcon = createIcon(CircleAlert);
